export const keyboardKeys = {
  ESCAPE: 'Escape',
}
